/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFuelFundedVendor.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/fuel-funded-vendor";

export class AutogenModelFuelFundedVendor<RowType extends ModelRow> extends Endpoint<RowType, RowFuelFundedVendorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFuelFundedVendor extends ModelRow<RowFuelFundedVendorFields> {
	constructor(values?: Partial<RowFuelFundedVendorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFuelFundedVendorFields {
	ap_glid: string;
	batchno: number;
	check_vendor_id: string;
	communication_type: string;
	company_id: string;
	connection_mode: string;
	connection_type: string;
	create_ap_voucher: string;
	create_expck_vouch: string;
	create_gl_entries: string;
	create_voucher: string;
	customer_id: string;
	efs_code: number;
	email_address: string;
	expired_in_days: number;
	express_check_glid: string;
	fuel_ap_div_id: string;
	fuel_interface_des: string;
	fuel_interface_id: string;
	host_password: string;
	host_server_name: string;
	hub_delta: number;
	ip_address: string;
	low_codes_email: string;
	low_codes_limit: number;
	low_codes_warning: string;
	master_account: string;
	pct_disc_passed: number;
	phone: string;
	plus_less: string;
	port: string;
	printer_address: string;
	provider_login: string;
	remote_directory: string;
	reorder_checks: number;
	security_card_no: string;
	update_hub: string;
	vendor_id: string;
	where_print: string;
	wire_ap_div_id: string;
	wire_default_subaccount: string;
}

